import { tx as translateInterfaceText } from '@/utils/i18n';
import { useLanguage } from '@/hooks/useLanguage';
import { useNewVideoModal } from '@/contexts/NewVideoModalContext';
import { UploadQueueModal } from './UploadQueueModal';
import { useNavigate } from 'react-router-dom';
import { toast } from '@/hooks/use-toast';

export function GlobalUploadModal() {
  useLanguage();
  const { isOpen, closeModal } = useNewVideoModal();
  const navigate = useNavigate();

  const handlePersonalize = (videoUrl: string, videoName: string) => {
    closeModal();
    
    // Navigate to personalizations with the video URL
    navigate('/personalizations', { 
      state: { 
        videoUrl, 
        videoName,
        fromUpload: true 
      } 
    });
    
    // Show success toast
    toast({
      title: translateInterfaceText("Vídeo carregado"),
      description: translateInterfaceText("\"{value0}\" está pronto para personalização", { value0: (videoName) }),
    });
  };

  return (
    <UploadQueueModal
      open={isOpen}
      onOpenChange={(open) => {
        if (!open) closeModal();
      }}
      onPersonalize={handlePersonalize}
      hideCloseControls={true}
    />
  );
}
